import { GLOBAL } from 'saddlebag-browser';

import { logError } from '../helpers/logger';

let hasLoggedMissingConfig = false;
const loggedConfigFailures = new Set<string>();

const logConfigFailure = (configGetter: string, key: string, error: Error) => {
  // A missing root config breaks every getter, so report it only once per page.
  if (!GLOBAL.getWindow()?.__internal?.config) {
    if (hasLoggedMissingConfig) return;

    hasLoggedMissingConfig = true;
    logError({
      error: new Error('Client config unavailable'),
      component: 'clientConfig',
      message: 'window.__internal.config is missing',
    });
    return;
  }

  // Preserve per-key diagnostics without logging failures again on repeated calls.
  const failureKey = `${configGetter}:${key}`;
  if (loggedConfigFailures.has(failureKey)) return;

  loggedConfigFailures.add(failureKey);
  logError({
    error: new Error(`${configGetter} failed`),
    component: String(configGetter),
    message: `While fetching ${key} ${configGetter} failed: ${error?.message}`,
  });
};

const getConfigServiceValue = (key: string) => {
  try {
    return GLOBAL.getWindow().__internal.config.configServiceValues[key];
  } catch (error) {
    logConfigFailure('getConfigServiceValue', key, error);
    return undefined;
  }
};

const getEnvConfig = (key: string) => {
  try {
    return GLOBAL.getWindow().__internal.config.envConfigValues[key];
  } catch (error) {
    logConfigFailure('getEnvConfig', key, error);
    return undefined;
  }
};

const getFeatureDecision = (key: string) => {
  try {
    return GLOBAL.getWindow().__internal.config.featuresDecisionValues[key];
  } catch (error) {
    logConfigFailure('getFeatureDecision', key, error);
    return undefined;
  }
};

const parseCsvConfigServiceValue = (raw: unknown): string[] =>
  (typeof raw === 'string' ? raw : '')
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);

export { getConfigServiceValue, getEnvConfig, getFeatureDecision, parseCsvConfigServiceValue };
